<template>
    <transition name="product">
        <div class="ClueQuery">
            <van-nav-bar
                    fixed
                    title="线索审核"
                    left-arrow
                    @click-left="$router.go(-1)">
            </van-nav-bar>
            <list-view ref="listView" :attr="attr" @request="onRequest">
                <template slot="content" slot-scope="{listData}">
                    <b-row>
                        <b-col cols="12" v-for="(item, index) in listData" :key="index">
                            <b-card style="width:95%;margin:0 auto;"
                                    class="mt-3 card-icon-bg card-icon-bg-primary o-hidden"
                                    @click="onItemClick(item)">
                                <div class="content d-flex van-row--justify-space-between">
                                    <p class="card-title text-break">{{ item.projectName }}</p>
                                    <div class="d-flex card-title" style="align-items: center">
                                        <van-tag
                                                class="parmary-color text-nowrap"
                                                style="margin: 0 10px"
                                        >{{ item.natureName }}
                                        </van-tag
                                        >
                                        <van-tag class="parmary-color text-nowrap">{{
                                            item.stausDescription
                                            }}
                                        </van-tag>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between fontSize">
                                    <span>项目名称：{{ item.projectName }}</span>
                                    <span>{{ item.creationTime | format("YYYY-MM-DD") }}</span>
                                </div>
                                <div class="mt-2 fontSize d-flex">
                                    <div style="width:18%;" class="text-nowrap text-break">项目概述：</div>
                                    <div style="width:83%;" class="text-monospace">
                                        {{ item.projectDescription }}
                                    </div>
                                </div>
                                <div class="mt-2 fontSize d-flex van-row--justify-space-between">
                                    <div>{{ item.companyName }}</div>
                                    <div>{{ item.industry }}</div>
                                </div>
                                <div class="mt-2 fontSize">
                                    <div>联系人：{{ item.contactPerson }}</div>
                                    <div class="mt-2">联系电话：{{ item.contactNumber }}</div>
                                    <div style="float: right;margin-top: -24px;" v-if="false">
                                        <van-button type="danger" size="mini"
                                                    style="margin: 0 10px;padding: 2px 16px;"
                                                    @click="onReject(item)">
                                            驳回
                                        </van-button>
                                        <van-button type="primary" size="mini"
                                                    style="padding: 2px 16px;"
                                                    @click=" onAgree(item)">
                                            同意
                                        </van-button>
                                    </div>
                                </div>
                                <div v-if="item.status == 20">
                                    <div class="pt-2 border-top fontSize mt-2 border-bottom-dotted-gray-1">
                                        <div>驳回原因：{{ item.reason }}</div>
                                        <div>{{ item.creationTime }}</div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </template>
            </list-view>
            <van-dialog v-model="show" title="驳回"
                        show-cancel-button
                        closeOnClickOverlay
                        :beforeClose="doReject">
                <div style="height:100%;">
                    <div style="height: calc(100% - 49px);">
                        <van-form ref="tableForm"
                                  :label-width="'64px'"
                                  :colon="true">
                            <van-field
                                    name="reson"
                                    v-model="rejectForm.reson"
                                    :rules="rejectFormRules.reson"
                                    rows="3"
                                    autosize
                                    label="驳回原因"
                                    type="textarea"
                                    maxlength="250"
                                    placeholder="请输入驳回原因"
                                    show-word-limit>
                            </van-field>
                            <van-field name="overruleStatus" :rules="rejectFormRules.overruleStatus" label="加入到企业黑名单">
                                <template #input>
                                    <van-radio-group v-model="rejectForm.overruleStatus" direction="horizontal">
                                        <van-radio name="0">不冻结</van-radio>
                                        <van-radio name="100">冻结15天</van-radio>
                                        <van-radio name="200">永久冻结</van-radio>
                                    </van-radio-group>
                                </template>
                            </van-field>
                        </van-form>
                    </div>
                </div>
            </van-dialog>
        </div>
    </transition>
</template>

<script>
    import listView from '@/components/list/index'
    export default {
        name: "ClueQuery",
        components: {listView},
        data() {
            return {
                loading: false,
                finished: false,
                show: false,
                list: [],
                form: {
                    PageSize: 5,
                    PageIndex: 0,
                },
                attr: {
                    current: 'current', // 响应当前页数
                    size: 'size', // 响应每页显示多少条,
                    pages: 'pages', // 响应总页数
                    total: 'totalCount', // 响应总数
                    records: 'items' // 响应数据
                },
                rejectForm: {
                    cluesId: '',
                    reson: '',
                    overruleStatus: ''
                },
                rejectFormRules: {
                    reson: [
                        {
                            required: true,
                            trigger: 'onBlur'
                        }
                    ],
                    overruleStatus: [
                        {
                            required: true,
                            trigger: 'onBlur'
                        }
                    ]
                }

            };
        },
        methods: {
            onRequest(val) {
                const $listView = this.$refs.listView;
                this.request({
                    url: "/v1.0/Clues/getCluesCheckList",
                    method: "GET",
                    params: {
                        PageSize: val.size,
                        PageIndex: val.current,
                        Status: '',
                        ProjectNature: '',
                        Contact: '',
                        ProjectName: '',
                        industry: '',
                        CheckStatus: ''
                    },
                }).then((res) => {
                    if (res.success) {
                        $listView.onNextSuccess(res.data);
                    } else {
                        $listView.onNextFailure();
                    }
                    this.$toast.clear();
                }).catch(() => {
                    $listView.onNextFailure();
                });
            },
            onReject(item) {
                this.show = true;
                this.rejectForm.cluesId = item.id;
                this.rejectForm.userId = item.userId;
                this.rejectForm.carryUserId = item.carryUserId;
                this.rejectForm.reson = '';
                this.rejectForm.overruleStatus = '';
                if (this.$refs.tableForm) {
                    this.$refs.tableForm.resetValidation();
                }
            },
            doReject(action, done) {
                const $listView = this.$refs.listView;
                if (action === 'confirm') {
                    this.$refs.tableForm.validate().then(valid => {
                        // submit
                        this.request({
                            url: "/v1.0/Clues/cluesOverrule",
                            method: "post",
                            data: this.rejectForm,
                        }).then((res) => {
                            done();
                            $listView.onRefresh();
                            this.$toast.clear();
                        }).catch(() => {
                            $listView.onRefresh();
                        });
                    }).catch(err => {
                        done(false);
                    });
                } else {
                    done();
                }
            },
            onAgree(item) {
                const $listView = this.$refs.listView;
                this.$dialog.alert({
                    message: '您确定审核通过',
                }).then(() => {
                    this.request({
                        url: "/v1.0/Clues/cluesCheckPassed",
                        method: "post",
                        data: {
                            cluesId: item.id,
                            userId: item.userId,
                            carryUserId: item.carryUserId,
                        },
                    }).then((res) => {
                        $listView.onRefresh();
                        this.$toast.clear();
                    }).catch(() => {
                        $listView.onRefresh();
                    });
                });
            },
            onItemClick(item) {
                this.$router.push(`/index/clueDetail?id=${item.id}`);
            }
        },
        created() {
        }
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/mixin.scss";
    .ClueQuery {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        overflow-x: hidden;
        background-color: rgb(247, 248, 250);
        z-index: 1;
    }
    .van-pull-refresh {
        margin-top: 46px;
        height: calc(100% - 46px);
    }
</style>
